import { render, staticRenderFns } from "./EmployeeEfficiencies.vue?vue&type=template&id=ecec63c6"
import script from "./EmployeeEfficiencies.vue?vue&type=script&lang=js"
export * from "./EmployeeEfficiencies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports